import { Search } from '@mui/icons-material';
import { SxProps, TextField } from '@mui/material';
import React, { useState } from 'react';
import { Colors } from '../../../utils/theme';

type IProps = {
  id: string;
  filter: (text: string) => void;
  sx?: SxProps;
};

const SearchInput: React.FunctionComponent<IProps> = ({ id, filter, sx }: IProps) => {
  const [searchValue, setSearchValue] = useState('');
  const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget;
    filter(value);
    setSearchValue(value);
  };

  return (
    <TextField
      id={id}
      variant="standard"
      data-testid={id}
      value={searchValue}
      onChange={handleValueChange}
      size="small"
      sx={{
        color: Colors.main,
        background: Colors.white,
        borderRadius: '9px',
        width: '100%',
        height: 36,
        ...sx
      }}
      placeholder={'Search...'}
      InputProps={{
        endAdornment: <Search style={{ color: Colors.main, width: 18, height: 18 }} />,
        disableUnderline: true,
        style: { marginTop: 'auto', marginBottom: 'auto', marginLeft: 24, marginRight: 16.5 }
      }}
      className={'custom-search'}
    />
  );
};

export default SearchInput;
